import i18nIsoCountries from 'i18n-iso-countries';
import { getCountries as getPhoneCountries, getCountryCallingCode } from 'libphonenumber-js';

import { Language } from '../config';

export type Country = { name: string; code: string; phoneCode: string };

const countryListsCache = {};

const generateCountryList: typeof getCountries = (language: Language) => {
  try {
    const i18nIsoCountry = require(`i18n-iso-countries/langs/${language}.json`);

    i18nIsoCountries.registerLocale(i18nIsoCountry);
  } catch (err) {
    console.warn(`Cannot load "i18n-iso-countries/langs/${language}.json"`, err);
  }

  const countryNamesMap = i18nIsoCountries.getNames(language, { select: 'official' });
  const countryNamesCodes = Object.keys(countryNamesMap);
  const phoneCodeIsoCodes = getPhoneCountries();

  const countryList = phoneCodeIsoCodes
    .filter((code) => countryNamesCodes.includes(code))
    .map((code) => ({
      name: countryNamesMap[code],
      code,
      phoneCode: getCountryCallingCode(code),
    }))
    .sort((c1, c2) => c1.name.localeCompare(c2.name));

  return countryList;
};

export function getCountries(language: Language = Language.et): Country[] {
  if (!countryListsCache[language]) {
    countryListsCache[language] = generateCountryList(language);
  }

  return countryListsCache[language];
}
